'use client';

// Error components must be marked as Client Components, even if re-exported.

export { default } from '@/base/app/[lang]/(main)/error';
